import { render, staticRenderFns } from "./customer_share_tpl.vue?vue&type=template&id=20546454&scoped=true&"
import script from "./customer_share_tpl.vue?vue&type=script&lang=js&"
export * from "./customer_share_tpl.vue?vue&type=script&lang=js&"
import style0 from "./customer_share_tpl.vue?vue&type=style&index=0&id=20546454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20546454",
  null
  
)

export default component.exports